export class MedianFilter {
    constructor(_windowSize = 5, _threshold = 50) {
        this._windowSize = _windowSize;
        this._threshold = _threshold;
        if (_windowSize % 2 === 0) {
            throw new Error("Window size must be odd.");
        }
    }
    apply(values, x, y, width, height) {
        const edge = Math.floor(this._windowSize / 2);
        const result = new Float32Array(values.length);
        values.copyWithin(0, 0);
        for (let i = 0; i < height; i++) {
            for (let j = 0; j < width; j++) {
                const window = [];
                for (let wi = Math.max(-edge, -i); wi <= Math.min(edge, height - 1 - i); wi++) {
                    for (let wj = Math.max(-edge, -j); wj <= Math.min(edge, width - 1 - j); wj++) {
                        const index = (i + wi) * width + (j + wj);
                        window.push(values[index]);
                    }
                }
                window.sort((a, b) => a - b);
                const median = window[Math.floor(window.length / 2)];
                const currentIndex = i * width + j;
                const currentValue = values[currentIndex];
                if (Math.abs(currentValue - median) > this._threshold) {
                    result[currentIndex] = median;
                }
                else {
                    result[currentIndex] = currentValue;
                }
            }
        }
        return result;
    }
}
MedianFilter.Shared = new MedianFilter();
//# sourceMappingURL=tiles.codecs.filter.js.map